import { Divider, Flex, Gap, Typography } from "../../../../ppui";
import { OrganizationBx, OrganizationEmDetails } from "../../../style";
import useOrganizationView from "../organization.service";
import { EMP_SETUP_CONST } from "./benefit-constant";

const OrganizationBenefitAdmin = () =>{
    const {
        configurationsInformation
    } = useOrganizationView()

    return <>
              <Flex justifyContent="space-between" gap={"10"}>
                <Typography variant="h5" mb={"0"}>
                  Organization Benefits Details
                </Typography>
              </Flex>
              <Gap height={30} />
              <OrganizationEmDetails>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Bonus Status
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.bonus_status === true ? "Yes" : "No"}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Ex Gratia
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.ex_gratia === true ? "Yes" : "No"}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Incentive Application
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.incentive_application === true ? "Yes" : "No"}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    OT Application
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.ot_application === true ? "Yes" : "No"}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Labour Welfare Fund
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.labour_welfare_fund === true ? "Yes" : "No"}
                  </Typography>
                </OrganizationBx>
              </OrganizationEmDetails>
              <Divider gap={20} />
              <Flex justifyContent="space-between" gap={"10"}>
                <Typography variant="h5" mb={"0"}>
                  Employment Setup
                </Typography>
              </Flex>
              <Gap height={30} />
              <OrganizationEmDetails>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Employment Setup
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.employmentType
                      ?.map((id) => {
                        const item = EMP_SETUP_CONST?.employmentType?.options?.find(
                          (obj) => obj?.id === id
                        );
                        return item ? item.name : null;
                      })
                      .filter((name) => name)
                      .join(", ")}
                  </Typography>
                </OrganizationBx>
    
                {/* <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Provision Period
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.isProvisionPeriod === true ? "Yes" : "No"}
                  </Typography>
                </OrganizationBx> */}
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Provision Days
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.provisionDays
                      ? configurationsInformation?.provisionDays
                      : "No"}
                  </Typography>
                </OrganizationBx>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Notice Period
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.isNoticePeriod === true ? "Yes" : "No"}
                  </Typography>
                </OrganizationBx>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Notice Days
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.noticeDays
                      ? configurationsInformation?.noticeDays
                      : "No"}
                  </Typography>
                </OrganizationBx>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Employee Prefix Code
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.prefix
                      ? configurationsInformation?.prefix
                      : "N/A"}
                  </Typography>
                </OrganizationBx>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Weekly Off
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.leave_staging?configurationsInformation?.leave_staging===true?"Organization Label":"Employee Label":"N/A"}
                  </Typography>
                </OrganizationBx>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Leave Period
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                
                  {configurationsInformation?.leave_type
                      ? configurationsInformation?.leave_type==="calender_year"?"Calender Year":"Financial Year"
                      : "No"}
                  </Typography>
                </OrganizationBx>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Work Location
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
    
    
                  {configurationsInformation?.workMode
                      ?.map((id) => {
                        const item = EMP_SETUP_CONST?.workMode?.options?.find(
                          (obj) => obj?.id === id
                        );
                        return item ? item.name : null;
                      })
                      .filter((name) => name)
                      .join(", ")}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Login Time
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.loginTime} hr
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Logout Time
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.logoutTime} hr
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Break Time
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {configurationsInformation?.breakTime} min
                  </Typography>
                </OrganizationBx>
                
              </OrganizationEmDetails>
            </>
}

export default OrganizationBenefitAdmin